module.exports = __webpack_public_path__ + "static/img/14.e2eade8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/sp/14.png
// module id = W6jI
// module chunks = 0